module.exports = __webpack_public_path__ + "static/media/theoryLoggedandNotLogged.e49921de.jpg";